import InspectionEntityItemsHelper from '@/_legacy/helpers/inspectionEntityItemsHelper';

export default {
  computed: {
    inspection() {
      return this.$store.getters['conduct/inspection'];
    },
    inspectionEntityItems() {
      return InspectionEntityItemsHelper.inspectionEntityItems(this.$store.getters.loggedInUserDetail, this.inspection);
    },
  },
};
